import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import {
    canSeeApplicationsPage, canSeeDatabasePage, canSeeGroupsPage,
    canSeeServersPage, canSeeUsersPage, canSeeWorkspacesPage, hideGroups
} from '../../../stores/auth/selectors';
import { activePage } from '../../../stores/navigation/selectors';
import { RootState } from '../../../stores/store';

interface Props extends LocalizeContextProps, RouteComponentProps {
    active: string;
    canSee: {
        users: boolean;
        applications: boolean;
        groups: boolean;
        workspaces: boolean;
        servers: boolean;
        database: boolean;
    };
    hideGroups?: boolean;
}

class PageNav extends React.Component<Props> {
    public render() {
        const t = this.props.translate;
        return (
            <React.Fragment>
                {this.props.canSee.users ? (
                    <li className={this.props.active === 'users' ? 'active' : ''}>
                        <Link to={'/users'}>
                            <FontAwesomeIcon icon={['fal', 'user']} />{t('sidebar.button.users')}
                        </Link>
                    </li>
                ) : null}
                {this.props.canSee.applications ? (
                    <li className={this.props.active === 'applications' ? 'active' : ''} >
                        <Link to={'/applications'}>
                            <FontAwesomeIcon icon={['fal', 'cogs']} />{t('sidebar.button.applications')}
                        </Link>
                    </li>
                ) : null}
                {this.props.hideGroups === false && this.props.canSee.groups ? (
                    <li className={this.props.active === 'groups' ? 'active' : ''}>
                        <Link to={'/groups'}>
                            <FontAwesomeIcon icon={['fal', 'users']} />{t('sidebar.button.groups')}
                        </Link>
                    </li>
                ) : null}
                {this.props.canSee.workspaces ? (
                    <li className={this.props.active === 'workspaces' ? 'active' : ''}>
                        <Link to={'/workspaces'}>
                            <FontAwesomeIcon icon={['fal', 'folder-open']} />{t('sidebar.button.workspaces')}
                        </Link>
                    </li>
                ) : null}
                {this.props.canSee.servers ? (
                    <li className={this.props.active === 'servers' ? 'active' : ''}>
                        <Link to={'/servers'}>
                            <FontAwesomeIcon icon={['fal', 'server']} />{t('sidebar.button.servers')}
                        </Link>
                    </li>
                ) : null}
                {this.props.canSee.database ? (
                    <li className={this.props.active === 'database' ? 'active' : ''}>
                        <Link to={'/database'}>
                            <FontAwesomeIcon icon={['fal', 'database']} />{t('sidebar.button.database')}
                        </Link>
                    </li>
                ) : null}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    active: activePage(state),
    canSee: {
        applications: canSeeApplicationsPage(state),
        database: canSeeDatabasePage(state),
        groups: canSeeGroupsPage(state),
        servers: canSeeServersPage(state),
        users: canSeeUsersPage(state),
        workspaces: canSeeWorkspacesPage(state),
    },
    hideGroups: hideGroups(state),
});

export default connect(mapStateToProps)(withLocalize(withRouter(PageNav)));